import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    card: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '20px',
      backgroundColor: theme.palette.background.paper,
      width: 270,
      height: 250,
      padding: 20,
      justifyContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        maxWidth: 330,
      },
      [theme.breakpoints.down('sm')]: {
        margin: 'auto',
      },
    },
    descriptionInfo: {
      display: 'flex',
      rowGap: 10,
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    image: {
      width: 90,
      height: 90,
    },
  });

export default styles;
